import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { ClipLoader } from "react-spinners";

import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import { useParams } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";
import PageHero from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import { SectionHeading } from "components/misc/Headings";
import EnquiryCard from "components/home-cards/EnquiryCard";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import Slider from "react-slick";
import DestinationCard from "components/destination-cards/DestinationCard";
import GalleryCard from "components/destination-cards/GalleryCard";
import ItineraryCard from "components/destination-cards/ItineraryCard"
import AttractionSlider from "components/destination-cards/AttractionSlider";
import WeatherCard from "components/destination-cards/WeatherCard";
import LocalCulture from "components/destination-cards/LocalCulture";
import HotelSlider from "components/destination-cards/HotelSlider";
import TourSlider from "components/destination-cards/TourSlider";
import SafetyCard from "components/destination-cards/SafetyCard";
import VisaCard from "components/destination-cards/VisaCard";
import VideoWrapper from "components/destination-cards/VideoWrapper";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const MapContainer = tw.div`w-full h-96 mt-10`;
const CardGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10`;
const Card = tw.div`bg-white rounded-lg shadow-lg p-6`;
const TimelineContainer = tw.div`mt-10 border-l-4 border-[#0049AC] pl-6`;
const TimelineItem = tw.div`mb-8`;
const TimelineTitle = tw.h3`text-lg font-bold text-[#0049AC]`;
const TimelineDescription = tw.p`text-gray-700`;

const Subheading = tw(SectionHeading)`mb-4 text-center text-2xl font-bold`;

const VideoContent = styled.div`
  ${tw`relative h-96 mt-10 bg-center bg-cover`}
`;

const VideoBackground = styled.video`
  ${tw`absolute top-0 left-0 w-full h-full`};
  object-fit: cover;
`;

const HeadingInfo = ({ subheading, ...props }) => (
  <div {...props}>
    {subheading ? <Subheading>{subheading}</Subheading> : null}
  </div>
);

const styles = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#fff",
  },
};


export default () => {
  const { id } = useParams();
  const [destination, setDestination] = useState(null);
  const [itinerary, setItinerary] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [weather, setWeather] = useState(null);
  const [hotels, setHotels] = useState([]);

  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.body.style.overflow = 'auto'
    const timer = setTimeout(() => {
      setLoading(false);
    }, 10000); // 10,000 milliseconds = 10 seconds

    return () => clearTimeout(timer); //
  });

  useEffect(() => {

    const fetchDestination = async () => {
      try {
        const response = await fetch(`${API_URL}/web/destinations/view/?destid=${id}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          setDestination(result.data[0])
        }
      } catch (error) {
        console.error('Error fetching destination data:', error);
      }
    };

    fetchDestination();

    const fetchVideo = async () => {
      try {
        const response = await fetch(`${API_URL}/web/destinations/main-video/?destid=${id}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          setVideoUrl(result.data[0].video_url)
          setLoading(false)
        }
      } catch (error) {
        console.error('Error fetching destination data:', error);
      }
    };

    fetchVideo();

  }, [id]);

  return (
    <AnimationRevealPage>

      {loading ?
        (<div style={styles.loaderContainer}>
          <ClipLoader size={60} color="#0049AC" />
          <p>Destination Loading...</p>
        </div>) :
        <>
          <PageHero pageName="Destinations" titleName={"Explore " + destination != null ? destination?.name : " - Destination Not Found"} />
          <Container>
            <br /><br />
            <DestinationCard destinationId={id} />
            {destination && <AttractionSlider destinationId={id} destinationName={destination?.name} />}<br />
            {destination && <WeatherCard lat={destination?.latitude} lon={destination?.longitude} destinationName={destination?.name}></WeatherCard>}
            {destination && <HotelSlider destinationName={destination?.name} destinationId={id} />}
            {destination && <LocalCulture destinationId={id}></LocalCulture>}
            {destination && <SafetyCard destinationId={id} destinationName={destination?.name}></SafetyCard>}
            {destination && <VisaCard destinationId={id}></VisaCard>}<br /><br /><br />
            {destination && <GalleryCard destinationId={id} />}<br /><br /><br />
            {destination && videoUrl && <VideoWrapper videoUrl={videoUrl} />}
            {destination && <TourSlider destinationName={destination?.name} destinationId={id} />}
          </Container>
          <EnquiryCard />
          <FooterCard />
        </>
      }
    </AnimationRevealPage>
  );
};
